define(
    'IMEIManager.Helper',
    [
        'IMEIManager.View'
    ],
    function (
        IMEIManagerView
    ) {

        return {

            getIMEIs: function getIMEIs() {
                var savedIMEI = window.sessionStorage.getItem('digi_imei');
                var imeis = [];

                if (savedIMEI) {
                    imeis = savedIMEI.split(',');
                }

                return imeis;
            },

            addIMEIs: function removeIMEIs(imeiText) {

                console.log('imeiText', imeiText)
                var currentList = this.getIMEIs();
                var inList = imeiText;
                var newList;

                if (inList && inList.length > 0) {
                    inList = inList.split(',');

                    newList = _.union(currentList, inList);

                    newList = _.uniq(newList);

                    window.sessionStorage.setItem('digi_imei', newList.toString());
                }

            },

            removeIMEIs: function removeIMEIs(imei) {
                var imeis = this.getIMEIs();

                imeis = _.reject(imeis, function (n) { return n == imei });

                window.sessionStorage.setItem('digi_imei', imeis.toString());

                return imeis;
            },
            clearIMEIs: function clearIMEIs() {
                window.sessionStorage.clear();
            }
        }

    });
